import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'
import qs from 'querystringify'
import { Toast } from 'vant'
// 取消重复请求
let pending = []
let cancelToken = axios.CancelToken
const source = cancelToken.source()

// 去重请求
let removePending = (config) => {
  /* eslint-disable */
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method + '&' + JSON.stringify(config.params || '')) {
      pending[p].f()
      pending.splice(p, 1)
    }
  }
}

// 验证请求是否存在
let cutReq = (config) => {
  const url = config.url
  for (let p in pending) {
    if (pending[p].u === url + '&' + config.method + '&' + JSON.stringify(config.params || '')) {
      return true
    }
  }
}

// console.log('env', process.env)
// create an axios instance
const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  baseURL: process.env.NODE_ENV != 'development' ? process.env.VUE_APP_BASE_API : '', // url = base url + request url
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    const { method, data, contentType, url } = config
    let flag = cutReq(config)
    if (flag === true) return null
    config.cancelToken = new cancelToken((c) => {
      const url = config.url
      pending.push({ u: url + '&' + config.method + '&' + JSON.stringify(config.params || ''), f: c })
    })
    // 拦截url中包含undefined的请求
    if (url.indexOf('undefined') > -1) {
      console.log('参数错误：' + url)
      source.cancel()
      config.cancelToken = source.token
      return
    } else {
      if (url.indexOf('/api/v2/szgouche2023/shops') > -1) {
        // 购车05 搜索车企
        config.baseURL = process.env.VUE_APP_V2_API
      }
    }
    // parse data
    if (contentType === 'json') {
      config.headers['Content-Type'] = 'application/json'
    } else if (method !== 'get' && _.isObject(data)) {
      if (typeof config.headers['Content-Type'] === 'undefined') {
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        config.data = qs.stringify(data)
      }
    }
    // 设置请求头
    if (sessionStorage.getItem('gc2209_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('gc2209_auth_token')
    }
    // 设置请求头
    if (sessionStorage.getItem('gc2303_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('gc2303_auth_token')
    }
    // 设置请求头
    if (sessionStorage.getItem('gc2305_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('gc2305_auth_token')
    }
    // 设置请求头
    if (sessionStorage.getItem('gc2308_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('gc2308_auth_token')
    }
    // 设置请求头
    if (sessionStorage.getItem('gxqgc2209_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('gxqgc2209_auth_token')
    }
    // 设置请求头
    if (sessionStorage.getItem('gxqgc2212_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('gxqgc2212_auth_token')
    }
    // 设置请求头
    if (sessionStorage.getItem('gxqgc2301_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('gxqgc2301_auth_token')
    }
    if (sessionStorage.getItem('tyg_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('tyg_auth_token')
    }
    if (sessionStorage.getItem('gchb_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('gchb_auth_token')
    }
    if (sessionStorage.getItem('redcross_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('redcross_auth_token')
    }
    if (sessionStorage.getItem('szd_open_auth_token')) {
      config.headers['auth'] = sessionStorage.getItem('szd_open_auth_token')
      config.headers['X-Authorization'] = sessionStorage.getItem('szd_open_auth_token')
    }
    // 读书打卡一期
    if (sessionStorage.getItem('szdReading_auth_token')) {
      config.headers['auth'] = sessionStorage.getItem('szdReading_auth_token')
      config.headers['X-Authorization'] = sessionStorage.getItem('szdReading_auth_token')
    }
    // 读书打卡二期
    if (sessionStorage.getItem('szdReading_auth_token_v2')) {
      config.headers['auth'] = sessionStorage.getItem('szdReading_auth_token_v2')
      config.headers['X-Authorization'] = sessionStorage.getItem('szdReading_auth_token_v2')
    }
    // 家装活动
    if (sessionStorage.getItem('szddecoration_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('szddecoration_auth_token')
    }
    // 88购车
    if (sessionStorage.getItem('szd88car_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('szd88car_auth_token')
    }
    if (sessionStorage.getItem('vitas2309_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('vitas2309_auth_token')
    }
    // szd20230925-苏周到邮储房贷申请
    if (sessionStorage.getItem('szd20230925-token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('szd20230925-token')
    }
    // szd20230925-苏周到邮储房贷申请
    if (sessionStorage.getItem('coffee2311_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('coffee2311_auth_token')
    }
    // 苏周到双十一文旅卡+惠玩卡活动
    if (sessionStorage.getItem('szd20231101-token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('szd20231101-token')
    }
    // 苏周到3周年
    if (sessionStorage.getItem('szd3zn_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('szd3zn_auth_token')
    }
    // 202311新能源购车补贴
    if (sessionStorage.getItem('gc2311_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('gc2311_auth_token')
    }
    // 设置请求头
    if (sessionStorage.getItem('gxqgouche231127_auth_token')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('gxqgouche231127_auth_token')
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log('---error---')
    console.log(error) // for debug
    pending = []
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    removePending(response.config)
    // 如果请求成功
    if (response.status == 200) {
      if (response.data.code == 401) {
        console.log(response.code)
        if (window.location.pathname.indexOf('gouchehongbao') != -1) {
          Toast('登录过期')
          sessionStorage.removeItem('gchb_auth_token')
          window.location.href = window.location.origin + '/gouchehongbao'
        }
        if (window.location.pathname.indexOf('gouche2209') != -1) {
          Toast('登录过期')
          sessionStorage.removeItem('gc2209_auth_token')
          window.location.href = window.location.origin + '/gouche2209'
        }
        if (window.location.pathname.indexOf('szdreading2306') != -1) {
          Toast('登录过期')
          sessionStorage.removeItem('szdReading_auth_token')
          window.location.href = window.location.origin + '/szdreading2306/home'
        }
        if (window.location.pathname.indexOf('szd88car230915') != -1) {
          Toast('登录过期')
          sessionStorage.removeItem('szd88car_auth_token')
          window.location.href = window.location.origin + '/szd88car230915/home'
        }
        if (window.location.pathname.indexOf('szd3zn') != -1) {
          Toast('登录过期')
          sessionStorage.removeItem('szd3zn_auth_token')
          window.location.href = window.location.origin + '/szd3zn/'
        }
      } else if (response.data.code == 501) {
        if (window.location.pathname.indexOf('szdreading2306') != -1 && sessionStorage.getItem('szdReading_auth_token')) {
          Toast('登录过期')
          sessionStorage.removeItem('szdReading_auth_token')
          window.location.href = window.location.origin + '/szdreading2306/home'
        }
        if (window.location.pathname.indexOf('szdreading2306') != -1 && sessionStorage.getItem('szdReading_auth_token_v2')) {
          Toast('登录过期')
          sessionStorage.removeItem('szdReading_auth_token_v2')
          window.location.href = window.location.origin + '/szdreading2306/v2/home'
        }
      } else if (response.data.code == 0) {
        return res
      } else {
        // 虎丘婚纱节 登录失效
        if (response.data.code == 50001) {
          return Promise.reject(res)
        } else if (response.data.code === 2353010010 || response.data.code === 230530501) {
          // 购车05
          return Promise.reject(response.data)
        } else if (location.pathname.indexOf('szd20230925') > -1) {
          // szd20230925 业务层需要code特殊处理
          return Promise.reject(response.data)
        } else if (location.pathname.indexOf('coffee2311') > -1) {
          // coffee2311 业务层需要code特殊处理
          return Promise.reject(response.data)
        } else {
          return Promise.reject(response.data.message || response.data.msg)
        }
      }
    } else {
      Toast('请求失败，请重新加载！')
      return Promise.reject(res.message || 'Error')
    }
  },
  (error) => {
    console.log('网络错误： ' + error)
    // if (!String(error).includes('cancelToken')) {
    //   Toast('网络异常请稍后重试！')
    // }
    pending = []
    return Promise.reject('网络异常请稍后重试！')
  }
)

Vue.$request = service
export default service
